// @vendors
const React = require('react');
const PropTypes = require('prop-types');
// @utility
const { formatText, FormattedText } = require('core/i18n').i18n;
// @commons
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');
const WizardError = require('components/commons/wizardError/wizardError');
//@constants
const { CARD_SIZE_MEDIUM } = require('constants/index');

class OpenYoungAddDocumentationError extends React.Component {

    render() {
        const {
            immCard,
            immVariables,
        } = this.props;
        const title = formatText('openYoungAddDocumentation-openYoungAddDocumentation_errorTitle');
        const goBackButtonLabel = formatText('openYoungAddDocumentation-openYoungAddDocumentation_backToCard');
        const linkToMovements = `/myprofile/cards/${immCard.get('cardId')}/movements`;
        const goBackButton = {
            label: goBackButtonLabel,
            url: linkToMovements
        };

        return (
            <div className="col-xs-12 col-md-offset-2 col-md-8">
                <WizardError
                    errorMessage={title}
                    mainButton={goBackButton}
                >
                    <section className="row">
                        <div className="col-xs-5">
                            <CommercialAds
                                immCard={immCard}
                                path="cards"
                                size={CARD_SIZE_MEDIUM}
                                type="cards"
                            />
                        </div>
                        <div className="col-xs-7">
                            <FormattedText
                                injectedStrings={[immVariables.getIn(['telefono', 'cliente'])]}
                                value="openYoungAddDocumentation-openYoungAddDocumentation_errorMessage"
                            />
                        </div>
                    </section>
                </WizardError>
            </div>
        );
    }
}

OpenYoungAddDocumentationError.propTypes = {
    immCard: PropTypes.object.isRequired,
    immVariables: PropTypes.object.isRequired,
};

module.exports = OpenYoungAddDocumentationError;